import React from 'react'
import { Button } from 'react-bootstrap'

export default class OrderReview extends React.Component {
  render() {
    return (
      <div className="text-left">
        <h6 className="mb-5">Name on Card: Christopher Walken</h6>
        <h6 className="mb-5">Address: 123 Kid Rock Lane</h6>
        <h6 className="mb-5">City: Vernal</h6>
        <div className="d-flex justify-content-between">
          <h6 className="mb-5">State: Utah</h6>
          <h6 className="mr-5 mb-5">Zip Code: 84078</h6>
        </div>
        <h6 className="mb-5">Country: United States</h6>
        <h6 className="mb-5">Card Number: ************1234</h6>
        <div className="d-flex justify-content-between">
          <Button className="btn btn-tomato mr-2">Pay $69.99</Button>
          <a className="mr-5 my-auto text-dec-none" href="#">
            <h6 className="mb-0">Edit Billing Information</h6>
          </a>
        </div>
      </div>
    )
  }
}
